import React, { useState } from 'react';
import { Grid, useTheme, DialogContent, DialogActions } from '@mui/material';
import MicNoneIcon from '@mui/icons-material/MicNone';
import { makeStyles } from '@mui/styles';
import Plyr from '@lwtears/lwt-common-frontend/lib/Player';
import { Box } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import CommonTranslationVariant from 'translations/variants/common';
import { translate } from 'translations/translator';
import { HwtButton } from 'components/@common/Buttons/HwtButton';

type Props = {
  onDelete: () => void;
  onSend: () => void;
  audioMessage: File;
  teacherInstructions: boolean;
};
const t = (key: CommonTranslationVariant) => translate('common', key);
export const PlayComponent: React.FC<Props> = ({
  onDelete,
  onSend,
  audioMessage,
  teacherInstructions
}) => {
  const theme = useTheme();
  const classes = useStyles(theme)();

  const [content, setContent] = useState<any>();

  const handleDelete = () => {
    onDelete();
  };

  const handleSend = () => {
    onSend();
  };

  const handleLoadedData = () => {
    const reader: any = new FileReader();

    reader.addEventListener('load', () => {
      setContent(reader.result);
    });
    reader.readAsDataURL(audioMessage);
  };

  const handleClose = () => null;
  const sendRecording = teacherInstructions
    ? t(CommonTranslationVariant.sendRecordingInstructions)
    : '';

  return (
    <Box>
      <DialogContent className={classes.content}>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <MicNoneIcon className={classes.icon} />
          <p className={classes.paragraph}>{sendRecording}</p>
          <Box className={classes.player}>
            <Plyr
              onEnter={handleLoadedData}
              media={{
                type: 'audio',
                source: {
                  src: content,
                  type: audioMessage.type
                }
              }}
              title={audioMessage.name}
              onDone={handleClose}
            />
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <HwtButton
          onClick={() => handleDelete()}
          variant="contained"
          color="secondary"
          startIcon={<DeleteIcon />}
          style={{
            width: '181px',
            marginRight: '16px',
            marginBottom: '16px'
          }}
        >
          {t(CommonTranslationVariant.delete)}
        </HwtButton>
        <HwtButton
          onClick={() => handleSend()}
          variant="contained"
          startIcon={<AddCircleIcon />}
          style={{
            width: '181px',
            marginRight: '16px',
            marginBottom: '16px'
          }}
        >
          {t(CommonTranslationVariant.sendRecording)}
        </HwtButton>
      </DialogActions>
    </Box>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    content: {
      width: '800px',
      height: '245px'
    },
    icon: {
      fontSize: '88px !important'
    },
    player: {
      width: '100%',
      paddingTop: '20px',
      paddingBottom: '20px'
    },
    paragraph: () => ({
      color: theme.palette.black.light,
      fontSize: '18px',
      fontWeight: 300,
      fontStyle: 'normal'
    }),
    deleteRecButton: () => ({
      width: '181px',
      height: '44px',
      fontSize: '16px',
      marginRight: '16px',
      marginBottom: '16px',
      textTransform: 'none',
      alignItems: 'normal',
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.light
      }
    })
  }));
